module.exports = __webpack_public_path__ + "img/15.84ec35a3.jpg";